"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_RiskAssessment_Prediction = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_Period_1 = require("./RTTI_Period");
exports.RTTI_RiskAssessment_Prediction = t.recursion('IRiskAssessment_Prediction', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        outcome: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        probabilityDecimal: t.number,
        _probabilityDecimal: RTTI_Element_1.RTTI_Element,
        probabilityRange: RTTI_Range_1.RTTI_Range,
        qualitativeRisk: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        relativeRisk: RTTI_decimal_1.RTTI_decimal,
        _relativeRisk: RTTI_Element_1.RTTI_Element,
        whenPeriod: RTTI_Period_1.RTTI_Period,
        whenRange: RTTI_Range_1.RTTI_Range,
        rationale: t.string,
        _rationale: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_RiskAssessment_Prediction.js.map